import type {ICampaignAbstract} from "./Campaign";

export const CampaignQueryParamName = "cm";

export type CampaignQueryParam = ICampaignAbstract | string;

export interface ICampaignContext {
    campaign?: CampaignQueryParam;
}